/*
  loading  -> lecturas (obtenerBloqueosActivos). Lo consume el "Cargando..." del listado.
  saving   -> escrituras (crear / cancelar / completar / eliminar). Lo consume el boton
              "Crear Bloqueo" para evitar el doble envio.

  Los flags los apaga siempre el finally de cada funcion del state, nunca las acciones de
  datos: asi una accion que no llegue a despacharse no puede dejar el boton trabado.
*/
export default (state, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };

    case "SET_SAVING":
      return {
        ...state,
        saving: action.payload,
      };

    case "SET_ERROR":
      return {
        ...state,
        error: action.payload,
      };

    case "OBTENER_BLOQUEOS":
      return {
        ...state,
        bloqueosList: action.payload,
        error: null,
      };

    case "AGREGAR_BLOQUEO":
      return {
        ...state,
        bloqueosList: Array.isArray(state.bloqueosList)
          ? [...state.bloqueosList, action.payload]
          : [action.payload],
        error: null,
      };

    case "AGREGAR_BLOQUEOS_MULTIPLES":
      return {
        ...state,
        bloqueosList: Array.isArray(state.bloqueosList)
          ? [...state.bloqueosList, ...action.payload]
          : action.payload,
        error: null,
      };

    case "ACTUALIZAR_BLOQUEO":
      return {
        ...state,
        bloqueosList: Array.isArray(state.bloqueosList)
          ? state.bloqueosList.map((b) =>
              b._id === action.payload._id ? action.payload : b
            )
          : [action.payload],
        error: null,
      };

    case "ELIMINAR_BLOQUEO":
      return {
        ...state,
        bloqueosList: Array.isArray(state.bloqueosList)
          ? state.bloqueosList.filter((b) => b._id !== action.payload)
          : null,
        error: null,
      };

    case "ELIMINAR_BLOQUEOS_MULTIPLES":
      return {
        ...state,
        bloqueosList: Array.isArray(state.bloqueosList)
          ? state.bloqueosList.filter((b) => !action.payload.includes(b._id))
          : null,
        error: null,
      };

    default:
      return state;
  }
};
